import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const UserWrapper = styled('section')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 24px;
`

export const SubSectionTitle = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme: { colors } }) => colors.greys[800]};
`
